// extracted by mini-css-extract-plugin
export default {"carouselSection":"MoreLikeThis_carouselSection__fXN1F"};